<template>
  <div class="" @click="select">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: "MenuItem",
  props: {
    title: {
      default: "",
      type: String
    },
    link: {
      default: "",
      type: String
    },
    action: {
      default: null,
      type: Function
    },
    actionText: {
      default: "",
      type: String
    }
  },
  methods: {
    select() {
      if (this.link) {
        this.$router.push({ name: this.link }).catch(() => {});
        this.$store.commit("app/hideMainMenu");
      } else if (typeof this.action === "function") {
        if (this.actionText !== "") this.action(this.actionText);
      } else {
        this.$emit("select");
      }
    }
  }
};
</script>

<style scoped>
/* .text {
  font-family: Quicksand;
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  line-height: 162.1%;
  display: flex;
  align-items: center;
  color: #ffffff;
} */
</style>
